import React from "react";
import { List, ListItem, Divider, ListItemText, ListItemAvatar, Avatar, Typography, styled } from "@mui/material";
import config from "../../config-site";

const address_api = config[0].address;

const labels = {
  0.5: 'خیلی ضعیف',
  1: 'بی فایده',
  1.5: 'ضعیف',
  2: 'پایین',
  2.5: 'معمولی',
  3: 'بهتر',
  3.5: 'خوب',
  4: 'بسیار خوب',
  4.5: 'عالی',
  5: 'بسیار عالی',
};

function getLabelText(value) {
  return `${labels[value]}`;
}

const BoldTypography = styled(Typography)({
  fontWeight: 'bold',
});

const RightAlignedTypography = styled(Typography)({
  fontFamily: 'b_mitra',
  textAlign: 'right',
});

function CommentMat({ comments }) {
  return (
    <React.Fragment>
      <List sx={{ width: '100%', maxWidth: 280, bgcolor: 'background.paper' }}>
        {comments && comments?.map(comment => (
          <div key={comment.id}>
            <ListItem alignItems="flex-start">
              <ListItemAvatar>
                <Avatar alt={comment.user.profile?.bio} src={`${address_api}${comment.user.profile?.image}`} />
              </ListItemAvatar>
              <ListItemText
                primary={
                  <BoldTypography>
                    {comment.user.profile?.bio}
                  </BoldTypography>
                }
              />
            </ListItem>
            <ListItem alignItems="flex-start">
              <ListItemText
                primary={
                  <>
                    <Typography component="span" variant="body2" color="textPrimary">
                      {comment.description}
                    </Typography>
                    <br />
                    <RightAlignedTypography component="span" variant="body2" color="textPrimary">
                      {comment.vote > 0 && (
                        <p>رای داده : <b>{getLabelText(comment.vote)}</b></p>
                      )}
                    </RightAlignedTypography>
                  </>
                }
              />
            </ListItem>
            <Divider />
          </div>
        ))}
      </List>
    </React.Fragment>
  );
}

export default CommentMat;
